<label class="checkbox">
    <input type="checkbox" 
        (change)="onChanged($event)"
        (blur)="onTouch()" 
        [checked]="isChecked"
        [disabled]="disabled"/>
    <span>{{ labelText }}</span>
</label>